import { createTheme } from "@material-ui/core";
import { blue, orange } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core";

export const theme = createTheme({
  palette: {
    primary: {
      main: blue[500],
    },
    secondary: {
      main: orange[500],
    },
  },
  typography: {
    fontFamily: ["sans-serif"],
  },
});

export const useStyles = makeStyles({
  customButtom: {
    borderRadius: 15,
    textTransform: "none",
    fontWeight: "bolder",
    color: "white",
    boxShadow: "none",
  },
  formControl: {
    margin: theme.spacing(1.1),
    width: 350,
    fontWeight: "bold",
  },
});
